const verticalScrollRegex = /(auto|scroll)/;

/**
 * Find the first vertical scroll parent of an element.
 * Minimal version of https://github.com/olahol/scrollparent.js/blob/master/scrollparent.js
 */

export function findScrollParent(node: Element): Element | Document {
    if (!node || node === document.body) {
        return document.body;
    }

    if (isVerticallyScrollable(node)) {
        return node;
    }

    if (!node.parentNode) {
        return document.body;
    }

    return findScrollParent(node.parentNode as Element);
}

function isVerticallyScrollable(node: Element): boolean {
    const style = getComputedStyle(node);

    if (!verticalScrollRegex.test(style.overflowY)) {
        return false;
    }

    // Only count it if the content actually overflows vertically
    return node.scrollHeight > node.clientHeight;
}
